export default __webpack_public_path__ + "static/media/4.64e2cc78.jpg";